





































// Importing components
import BaseAlertList from '@/ui/BaseAlertList.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheFormCategories',
    components: {
        BaseAlertList,
        BaseInputField,
    },
    props: {
        category: Object,
        errors: Array,
    },
    data() {
        return {};
    },
};
